import styled from "@emotion/styled";
import { fontIndivisibleVariable, theme } from "@product/scmp-sdk";

import { BaseEntityLink } from "shared/components/common/base-entity-link";

export const Container = styled.div`
  display: grid;
  grid:
    "section more" min-content
    "section others" 1fr / auto auto;
  grid-gap: 30px 64px;

  font-family: ${fontIndivisibleVariable};
`;

export const MenuSectionContainer = styled.div`
  grid-area: section;

  min-inline-size: 119px;
  max-inline-size: 295px;
`;

export const MenuItemLabel = styled.div`
  color: #ffffff;
  font-weight: 300;
  font-size: 14px;
  font-family: ${fontIndivisibleVariable};
  letter-spacing: -0.014px;
  text-transform: uppercase;
  font-variation-settings: "wght" 300;
`;

export const MenuSectionLinkContainer = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 10px;

  margin-block-start: 16px;
`;

export const StyledBaseEntityLink = styled(BaseEntityLink)`
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontIndivisibleVariable};
  line-height: 17px;
  letter-spacing: -0.014px;
  font-variation-settings: "wght" 500;
`;

export const MenuMoreContainer = styled.div`
  grid-area: more;
`;

export const MenuLinkContainer = styled.div`
  display: grid;
  grid-row-gap: 10px;

  margin-block-start: 16px;

  line-height: 17px;

  ${theme.breakpoints.up("tablet")} {
    grid-auto-flow: column;
    grid-template-rows: min-content min-content;
    grid-gap: 10px 72px;
  }
`;

export const Anchor = styled.a`
  color: #ffffff;
  font-size: 14px;
  font-family: ${fontIndivisibleVariable};
  letter-spacing: -0.014px;
  font-variation-settings: "wght" 500;
`;

export const MenuOthersContainer = styled.div`
  grid-area: others;
`;
